import { SpecificationsLibrary } from '@/components/specifications/SpecificationsLibrary';

export default function AdminSpecificationsPage() {
  return (
    <div className="container mx-auto max-w-7xl">
      <SpecificationsLibrary isAdminView={true} />
    </div>
  );
}
